import React, { Component } from 'react';
import { connect } from 'react-redux';
import SearchPage from '../search-page';
import RegionPage from '../region-page';
import EntityPage from '../entity-page';
import CompareSelectPage from '../compare-select-page';
import CompareSelectEntitiesPage from '../compare-select-entities-page';
import { fetchRegions } from '../../actions/regions';
import * as selectors from '../../reducers';
import styles from './root.module.scss';
import { setIsMobile } from '../../actions/ui';
import { debounce } from 'lodash';
class Root extends Component {
  componentDidMount() {
    this.props.fetchRegions();
    this.props.setIsMobile(window.innerWidth < 800);
    window.addEventListener(
      'resize',
      debounce(() => {
        this.props.setIsMobile(window.innerWidth < 800);
      }, 200)
    );
  }

  renderContent() {
    const { activePage } = this.props;
    switch (activePage) {
      case 'search':
        return <SearchPage />;
      case 'region':
        return <RegionPage />;
      case 'entity':
        return <EntityPage />;
      case 'compareSelectEntities':
        return <CompareSelectEntitiesPage />;
      case 'compareSelect':
        return <CompareSelectPage />;
      default:
        return <SearchPage />;
    }
  }

  renderRoot() {
    const { isFetchingCouncils } = this.props;
    if (isFetchingCouncils) {
      return (
        <div className={styles.loading}>
          <p className={styles.spinner}>Loading...</p>
        </div>
      );
    } else {
      return <div>{this.renderContent()}</div>;
    }
  }

  render() {
    return (
      <div className={styles.root + ' global-styles'}>{this.renderRoot()}</div>
    );
  }
}

const mapDispatchToProps = {
  fetchRegions,
  setIsMobile,
};

const mapStateToProps = (state) => ({
  isFetchingCouncils: selectors.getIsFetchingCouncils(state),
  activePage: selectors.getActivePage(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(Root);



// WEBPACK FOOTER //
// ./src/pages/root/root.js